import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import "../../../../assets/css/authenticationStyles.css";
import notap_logo from "../../../../assets/images/notap_logo.png";
import { clearAll } from "../../../../config/redux/slice/authSlice";
import { appUrls } from "../../../../utils/urls/appUrls";
import { appApi } from "../../../../utils/endpoints/appApi";
import { postRequest } from "../../../../helpers/request";
import {
  setErrorMessageBankUser,
  setLoadingBankUser,
} from "../../../../config/redux/slice/bankUserSlice";
import { AuthAlert, Spinner } from "../../../components";

export default function LinkVerificationError() {
  const dispatch = useDispatch();

  const [successMessage, setSuccessMessage] = useState(false);

  const {
    bankUserLoading,
    bankUserErrorMsg,
    certificateManagement: { otp, reference_number },
  } = useSelector((state) => state.bankUser);

  const { token } = useSelector((state) => state.authData);

  useEffect(() => {
    dispatch(clearAll({}));
  }, []);

  const requestLink = async (data) => {
    dispatch(clearAll({}));
    setSuccessMessage(false);
    // let email = decryptToken(encryted_email)
    const res = await postRequest(
      "",
      `${appApi.requestAnotherLink}`,
      { otp, reference: reference_number },
      dispatch,
      setLoadingBankUser,
      "",
      setErrorMessageBankUser,
    );
    if (res !== undefined && res.status < 400) {
      setSuccessMessage(true);
    }
  };

  const closeErrorAlert = () => {
    dispatch(setErrorMessageBankUser({ message: null }));
  };

  const closeSuccessAlert = () => {
    setSuccessMessage(false);
  };

  return (
    <div className="d-flex justify-content-center align-items-baseline profile-creation">
      <div
        style={{ marginTop: "4rem" }}
        className="card card-default pt-5 px-5 pb-0"
      >
        <div className="formContainer">
          <div
            style={{ columnGap: "1rem" }}
            className="d-flex align-items-center justify-content-center"
          >
            <img src={notap_logo} alt="logo" className="logotypeImage" />
            <h2 className="font-weight-bold">NOTAP Portal</h2>
          </div>
          <div
            style={{ columnGap: "0.8rem" }}
            className="greeting text-danger d-flex justify-content-center align-items-center"
          >
            <i style={{ fontSize: "1.5rem" }} className={`mdi mdi-alert`}></i>
            <p style={{ fontSize: "1.3rem" }} className={`text-capitalize`}>
              Link Verification Error
            </p>
          </div>
          <form className="mainForm">
            <div className="w-100 m-0">
              {successMessage && (
                <AuthAlert
                  onClick={closeSuccessAlert}
                  alertStyles={{ width: "95%", margin: "0 auto" }}
                  status="success"
                >
                  Confirmation of reasonableness request sent successfully
                </AuthAlert>
              )}
              {bankUserErrorMsg && (
                <AuthAlert
                  onClick={closeErrorAlert}
                  alertStyles={{ width: "95%", margin: "0 auto" }}
                  status="error"
                >
                  {bankUserErrorMsg}
                </AuthAlert>
              )}
              <div className="text-center mb-5" style={{ color: "#31343D" }}>
                <p style={{ lineHeight: "1.8rem" }}>
                  Your Authorization link has expired or is no longer valid.
                </p>
              </div>
              <div className="d-flex col-md-12 justify-content-center">
                {bankUserLoading ? (
                  <Spinner />
                ) : (
                  <button
                    type="button"
                    onClick={requestLink}
                    className="btn btn-primary mb-4"
                  >
                    Click Here To Request Another Link
                  </button>
                )}
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
